















































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import MainHeader from '@/components/MainHeader'
import TableComponent from '@/components/TableComponent'
import DocumentModal from '../DocumentModal'
//   import { FicationAdd, FicationEdit } from '@/api/advicenote'
import { FileTypeList, getByCusr, getselectAllVlaue } from '@/api/utils'
import {getLocalItem,} from '@/utils'
import {
  doAddSuperivision,
  getWritenSuperivisionInfo,
  changeDocStatus
} from '@/api/supervision'
//   import {getLocalItem} from '@/utils'
//   import Upload from '@/components/Uploader/index'
import store from '@/store'
import moment from 'moment'

@Component({
  name: 'Examine',
  components: { MainHeader, TableComponent, DocumentModal },
})
export default class SupervisionInfo extends Vue {
  $refs!: { table: HTMLFormElement; ruleForm: HTMLFormElement ; filetable:HTMLFormElement};
  // $refs!: { ruleForm: HTMLFormElement  }
  private docreason:any = ''
  private docvisible:any = false
  private form: any = '';
  private action: string = 'add';
  private showRtn: boolean = true;
  private showAddDoc: boolean = false;
  private showDCM: boolean = false;
  private person: any = [];
  private fileData:any = []
  private infoid: any = '';
  private docData: any = null;
  private headerArr = ['书面监察', '书面监察详情'];
  private actioning: string =
    process.env.VUE_APP_API_BASE_URL +
    '/front/supervision/v1/supervisionUploadFile/commonUpload';
  private loading: boolean = false;
  private visible: boolean = false;
  private recordId: string = '';
  private promas: any = {};
  private user: any = '';
  private regionList: any = [];
  private hint: boolean = false;
  private filelistType: any = '';
  private dataSource: any = [];
  private fileTypeId: any = '';
  private datalevel: any = [];
  private idauthentication: string = '';
  private uploadata: any = {};
  
     private client:any =getLocalItem('client')
  private fileList: any = []; //编辑的时候改变它
  private headers: any = {
    Authorization: Vue.ls.get('ACCESS_TOKEN'),
  };
  private images: any = {};
  private columns: any = [
    {
      title: '文件名称',
      dataIndex: 'documentName',
      key: 'documentName',
      customRender: (text: any, row: any, index: any) => {
        return text ? text : '-'
      },
    },
    {
      title: '下发时间',
      dataIndex: 'documentIssueTime',
      key: 'documentIssueTime',
      // customRender: (text: any, row: any, index: any) => {
      //   return text ? text : '-'
      // },
    },
    {
      title: '下发状态',
      dataIndex: 'documentIssueState',
      key: 'documentIssueState',
      customRender: (text: any, row: any, index: any) => {
          
        return text===2 ? '已下发' : '未下发'
      },
    },
    {
      title: '操作',
      key: 'action',
      scopedSlots: { customRender: 'action' },
    },
  ];
  private filecolumns:any = [
     {
      title: '文件名/rar',
      dataIndex: 'fileName',
      key: 'fileName',
    
      ellipsis: true,
      // customRender: (text: any, row: any, index: any) => {
      //   return text ? text : '-'
      // },
    },
    {
      title: '上传时间',
      dataIndex: 'createTime',
      key: 'createTime',
      // customRender: (text: any, row: any, index: any) => {
      //   return text ? text : '-'
      // },
    },
    {
      title: '文件大小',
      dataIndex: 'fileSize',
      key: 'fileSize',
      customRender: (text: any, row: any, index: any) => {
          if((text/1024)/1024<1){
              return (text/1024) + 'kb'
          } else {
           return (text/1024)/1024 + 'M'
          }
        
      },
    },
    {
      title: '操作',
      key: 'action',
      scopedSlots: { customRender: 'action' },
    },
  ]
  disabledDate(current: any) {
    return current < moment().subtract(0, 'day') //今天之前的年月日不可选，不包括今天
  }
  /** 下拉绑定 */
  filterOption(input: any, option: any) {
    return (
      option.componentOptions.children[0].text
        .toLowerCase()
        .indexOf(input.toLowerCase()) >= 0
    )
  }
  handleEdit() {
    this.showDCM = true
    this.showAddDoc = true
  }
  private supervisionPlanTime: any = '';
  onChangeTime(date: any, dateString: any) {
    this.supervisionPlanTime = dateString
  }
  addDoc() {
    if (this.tableData.length > 0) {
      this.$message.warning('当前记录只能添加一条文书')
      return
    }
    this.showDCM = true
    this.showAddDoc = true
  }
  docCallBack(data: any) {
    this.docData = data
    if (this.tableData.length > 0) {
      this.tableData = []
    }
    this.tableData.push(data)

  }
  handDeletDoc() {
    this.tableData = []
    this.$refs.table.refresh(true)
  }
  closeDoc() {
    this.showDCM = false
    this.showAddDoc = false
  }
  // 将已上传的文件id发送后端绑定
  issueAnotice(val: number) {
    this.form.validateFields((err: any, value: any) => {
      if (!this.docData) {
        this.$message.warning('请添加一个文书')
        return false
      }
      if (!err) {
        const postData: any = {}
        postData.enterpriseCustId = value.enterpriseCustId.key
        postData.status = val
        postData.lawEnforcerUserList = value.lawEnforcerUserList.map(
          (item: any) => {
            return item.key
          }
        )
        postData.documentInfo = this.docData
        postData.supervisionPlanTime = this.supervisionPlanTime
     
        doAddSuperivision(postData).then((res: any) => {
          if (res && res.status === 0) {
            if (val === 1) {
              this.$message.success('新增成功')
            } else {
              this.$message.success('保存并下发成功')
            }
            this.handleReturn()
          } else {
            this.$message.error(res.message)
          }
        })
      }
    })
  }

  upLoding(data: any) {
    var _this = this
    const timeage = moment(new Date()).format('YYYY-MM-DD')
  }
  // cancel 取消
  handlecancel() {
    this.visible = false
    this.fileList = []
    this.datalevel = []
  }
  handleDoccancel(){
    this.docvisible = false
    this.docreason = ''
  }
  // OK确认
  handleOk() {
    this.fileList = []
    this.visible = false
  }
  // 返回按钮
  handleReturn() {
    this.$router.replace({ name: 'WrittenSupervision' })
  }
  private tableData: any = [];
  private getList() {
    const that = this
    return new Promise(function (resolve: any, reject: any) {
      const data = {
        status: 0,
        data: that.tableData,
      }
      return resolve(data)
    })
  }
private getfileList(){
    const that = this
    return new Promise(function (resolve: any, reject: any) {
      const data = {
        status: 0,
        data: that.fileData,
      }
      return resolve(data)
    })
}
 private pdfUrl:any = ''
 private isInfo:any =false
  derlogin(row: any) {
    if(row.documentFileUrl){
        this.visible = true
        this.pdfUrl =  row.documentFileUrl
    } else {
        this.docData = row
    // this.docID= row.id
    this.isInfo = true
    this.showDCM = true
    this.showAddDoc = true
    }

    this.filelistType = row.fileType * 1
  }
  mounted() {
    getselectAllVlaue().then((res) => {
      this.person = res.data
    })
  }
  examine(type:any){
    const postdata:any = {
      status:type,
      recordId:this.infoid
    }
  

    if(type!==8){
      changeDocStatus(postdata).then((res:any)=>{
        if(res&&res.status===0){
          this.$message.success('操作成功')
          this.handleReturn()
        } else {
          this.$message.error(res.message)
        }
      })
    } else {
      this.docvisible = true
    }

  }
  handleDocOk(){
    if(this.docreason===''){
      this.$message.warning('请先输入驳回原因')
      return false
    }
     const postdata:any = {
      status:8,
      recordId:this.infoid,
      rejectReason:this.docreason
    }
     changeDocStatus(postdata).then((res:any)=>{
        if(res&&res.status===0){
          this.$message.success('操作成功')
          this.handleReturn()
        } else {
          this.$message.error(res.message)
        }
      })

  }
  private infoData: any ={
    documentInfo:{}
  };
  created() {
    this.form = this.$form.createForm(this)
    this.infoid = this.$route.query.id
    getWritenSuperivisionInfo(this.infoid).then((res: any) => {
      if (res && res.status === 0) {
        this.infoData = res.data
        this.$nextTick(() => {
          this.form.setFieldsValue({
            enterpriseCustId: {
              key: res.data.enterpriseCustId,
              label: res.data.enterpriseCustName,
            },
            lawEnforcerUserList: res.data.lawEnforcerUserList.map(
              (item: any) => {
                return {
                  key: item.lawEnforcerUserId,
                  label: item.lawEnforcerUserName,
                }
              }
            ),
            supervisionPlanTime:moment(res.data.supervisionPlanTime).format('YYYY-MM-DD HH:mm:ss') ,
          })
        })
        this.tableData.push(res.data.documentInfo)
        this.fileData = res.data.enterpriseFileInfoList
        this.$refs.filetable.refresh(true)
        // this.fileData.push(res.data.)
        // this.getfileList()
      }
    })
    getByCusr().then((res) => {
      this.regionList = res.data
    })
  }
}
